






































































































































































import moment from 'moment'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import RegrasDeCalculoStore from '@/components/RemuneracaoMedica/RegrasDeCalculo/Store/RegrasDeCalculoStore'
import { onlyFloat } from '@/utils/common'

@Component
export default class RegraDeCalculoForm extends Vue {
  get getRegrasDeCalculoStore() {
    return getModule(RegrasDeCalculoStore, this.$store)
  }

  get valoresDeReferencia() { return this.getRegrasDeCalculoStore.valoresDeReferencia }
  get valorReferenciaTipos() { return this.getRegrasDeCalculoStore.valorReferenciaTipos }

  get medicoRecebimentoTipos() {
    return [
      { key: null, display: 'Nenhum' },
      { key: 'material_repasse', display: 'Material' },
      { key: 'procedimento_repasse', display: 'Procedimento' },
      { key: 'repasse_terceiro_item', display: 'Repasse terceiro item' },
      { key: 'garantia_periodo', display: 'Agenda garantia mínima período' },
      { key: 'repasse_indicacao', display: 'Repasse indicação' },
      { key: 'garantia_incremental', display: 'Garantia incremental' },
      { key: 'garantia_media_mensal', display: 'Garantia média mensal' },
      { key: 'plantao', display: 'Plantão' },
      { key: 'exame', display: 'Exame' },
    ]
  }

  dicaNumeric: string = 'Use somente números inteiros ou decimais separados por ponto (.)'
  dicaFatores: string = 'Para valores como 30%, por exemplo, escreva 0.3. 150%, escreva 1.5, etc.'

  onlyFloatUtil(value: string) {
    return onlyFloat(value)
  }

  setTabelaPrecoId(e: boolean | null | undefined) {
    if (e) this.getRegrasDeCalculoStore.setRegraDeCalculoField({ field: 'tabelaPrecoId', value: null })
  }

  displayDateAndHours(value: any) {
    if (['', null, undefined].includes(value)) return ' - '
    return moment(value).format('DD/MM/YYYY HH:mm')
  }

  @Watch('getRegrasDeCalculoStore.regraDeCalculo.valorDeReferencia')
  onValorDeReferenciaChange(value: any) {
     switch (value) {
    case 'Fixo':
      this.getRegrasDeCalculoStore.regraDeCalculo.tabelaPrecoId = null
      this.getRegrasDeCalculoStore.regraDeCalculo.considerarValorPacote = false
      this.getRegrasDeCalculoStore.regraDeCalculo.tabelaPrecoPropria = false
      this.getRegrasDeCalculoStore.regraDeCalculo.considerarTabelaPrecoPontuacao = false
      break
    case 'Faturado':
    case 'FaturadoProfissional':
      this.getRegrasDeCalculoStore.regraDeCalculo.tabelaPrecoId = null
      this.getRegrasDeCalculoStore.regraDeCalculo.valorDeReferenciaFixo = null
      this.getRegrasDeCalculoStore.regraDeCalculo.valorDeReferenciaTipo = null
      this.getRegrasDeCalculoStore.regraDeCalculo.tabelaPrecoPropria = false
      this.getRegrasDeCalculoStore.regraDeCalculo.considerarTabelaPrecoPontuacao = false
      break
    case 'Tabela':
      this.getRegrasDeCalculoStore.regraDeCalculo.valorDeReferenciaFixo = null
      this.getRegrasDeCalculoStore.regraDeCalculo.valorDeReferenciaTipo = null
      this.getRegrasDeCalculoStore.regraDeCalculo.considerarValorPacote = false
      break
    default:
      this.resetFields()
      break
  }
}

  resetFields() {
    this.getRegrasDeCalculoStore.regraDeCalculo.valorDeReferenciaFixo = null
    this.getRegrasDeCalculoStore.regraDeCalculo.valorDeReferenciaTipo = null
    this.getRegrasDeCalculoStore.regraDeCalculo.tabelaPrecoId = null
    this.getRegrasDeCalculoStore.regraDeCalculo.considerarValorPacote = false
    this.getRegrasDeCalculoStore.regraDeCalculo.tabelaPrecoPropria = false
    this.getRegrasDeCalculoStore.regraDeCalculo.considerarTabelaPrecoPontuacao = false
  }
}
